/**
 * NEAR RPC API request types and responses
 * @module
 */
export var IdType;
(function (IdType) {
    IdType["Transaction"] = "transaction";
    IdType["Receipt"] = "receipt";
})(IdType || (IdType = {}));
